/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as LayoutScanPayIdImport } from './routes/_layout.scanPay.$id'
import { Route as LayoutPayIdImport } from './routes/_layout.pay.$id'
import { Route as LayoutMysellIdImport } from './routes/_layout.mysell.$id'

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LayoutScanPayIdRoute = LayoutScanPayIdImport.update({
  id: '/scanPay/$id',
  path: '/scanPay/$id',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPayIdRoute = LayoutPayIdImport.update({
  id: '/pay/$id',
  path: '/pay/$id',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMysellIdRoute = LayoutMysellIdImport.update({
  id: '/mysell/$id',
  path: '/mysell/$id',
  getParentRoute: () => LayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/_layout/mysell/$id': {
      id: '/_layout/mysell/$id'
      path: '/mysell/$id'
      fullPath: '/mysell/$id'
      preLoaderRoute: typeof LayoutMysellIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/pay/$id': {
      id: '/_layout/pay/$id'
      path: '/pay/$id'
      fullPath: '/pay/$id'
      preLoaderRoute: typeof LayoutPayIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/scanPay/$id': {
      id: '/_layout/scanPay/$id'
      path: '/scanPay/$id'
      fullPath: '/scanPay/$id'
      preLoaderRoute: typeof LayoutScanPayIdImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutRouteChildren {
  LayoutMysellIdRoute: typeof LayoutMysellIdRoute
  LayoutPayIdRoute: typeof LayoutPayIdRoute
  LayoutScanPayIdRoute: typeof LayoutScanPayIdRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutMysellIdRoute: LayoutMysellIdRoute,
  LayoutPayIdRoute: LayoutPayIdRoute,
  LayoutScanPayIdRoute: LayoutScanPayIdRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/mysell/$id': typeof LayoutMysellIdRoute
  '/pay/$id': typeof LayoutPayIdRoute
  '/scanPay/$id': typeof LayoutScanPayIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/mysell/$id': typeof LayoutMysellIdRoute
  '/pay/$id': typeof LayoutPayIdRoute
  '/scanPay/$id': typeof LayoutScanPayIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/mysell/$id': typeof LayoutMysellIdRoute
  '/_layout/pay/$id': typeof LayoutPayIdRoute
  '/_layout/scanPay/$id': typeof LayoutScanPayIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '' | '/mysell/$id' | '/pay/$id' | '/scanPay/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '' | '/mysell/$id' | '/pay/$id' | '/scanPay/$id'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/_layout/mysell/$id'
    | '/_layout/pay/$id'
    | '/_layout/scanPay/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/mysell/$id",
        "/_layout/pay/$id",
        "/_layout/scanPay/$id"
      ]
    },
    "/_layout/mysell/$id": {
      "filePath": "_layout.mysell.$id.tsx",
      "parent": "/_layout"
    },
    "/_layout/pay/$id": {
      "filePath": "_layout.pay.$id.tsx",
      "parent": "/_layout"
    },
    "/_layout/scanPay/$id": {
      "filePath": "_layout.scanPay.$id.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
